import { ComponentProps } from 'react';

import { PngIcon } from 'ui-kit';

type MainNavIconProps = Pick<ComponentProps<typeof PngIcon>, 'name' | 'size'>;

// Decorative: every main nav link already carries its label as text or aria-label.
export const MainNavIcon = ({ name, size }: MainNavIconProps) => (
  <span className="flex flex-none light:brightness-75 light:contrast-150 light:drop-shadow-[0_1px_1px_rgba(0,0,0,0.25)] light:saturate-150">
    <PngIcon name={name} size={size} alt="" />
  </span>
);
